import { MarkingWidget } from '@/widgets/settings'

export const MarkingPage = () => {
    return <MarkingWidget />
}
